export default __webpack_public_path__ + "fonts/reason-img1.svg";